import React from 'react';
import { AiOutlineMenu, AiOutlineLogin, AiOutlineBell, AiOutlineUser, AiOutlineArrowRight } from 'react-icons/ai'
import logo from '../../Assert/gb-logo.png'
import { IoCallOutline } from 'react-icons/io5'
import { VscSearch } from 'react-icons/vsc'
import { FaRegCopy } from 'react-icons/fa'
import { BiRadioCircle } from 'react-icons/bi'
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { searchInput } from '../../redux/slice/productslice';

const Header = ({ cat, setCate }) => {
    const dispatch = useDispatch()
    const searchText = useSelector((state) => state.cart.search)



    return (
        <>
            <div className="navbar  shadow-lg font-semibold p-0 fixed top-0 w-full z-10" style={{ backgroundColor: "#000", color: "#fff" }}>

                <div className="navbar-start m-3">
                    <div className='flex gap-x-2  md:hidden'>
                        {cat ? <AiOutlineArrowRight className='text-2xl font-bold ' onClick={() => setCate(!cat)}></AiOutlineArrowRight> : <AiOutlineMenu className='text-2xl font-bold ' onClick={() => setCate(!cat)}></AiOutlineMenu>}

                    </div>
                    <NavLink to={'/'} className="md:w-40 md:h-12 w-40"> <img src={logo} className='w-40 h-full' alt="" /></NavLink>
                    <div className='md:flex gap-x-2 items-center ml-1 hidden'>
                        {cat ? <AiOutlineMenu className='text-2xl font-bold ' onClick={() => setCate(!cat)}></AiOutlineMenu> : <AiOutlineArrowRight className='text-2xl font-bold ' onClick={() => setCate(!cat)}></AiOutlineArrowRight>}
                        <span className='hidden sm:flex tracking-wider'>Categories</span>
                    </div>
                </div>



                <div className="w-full">
                    <div className="form-control w-full lg:block hidden ">
                        <div className="relative bg-white shadow-sm rounded-full">
                            <input value={searchText} onChange={(e) => dispatch(searchInput(e.target.value))} type="text" placeholder="Search For Your Products like rice, pottato" className="w-full py-3 px-8 rounded-full outline-0 border-0 text-black font-semibold tracking-wider" />
                            <button className="absolute top-0 right-0 rounded-full btn bg-gradient-to-t hover:from-red-800 hover:to-red-400 from-red-600 to-red-300 border-0 outline-0 "><VscSearch /></button>
                        </div>
                    </div>
                </div>

                <div className="navbar-end  gap-x-2">

                    {/* Call Under Header */}

                    <button className="btn btn-ghost btn-circle bg-white outline-none border-none dropdown dropdown-end md:flex justify-center hidden hover:text-white">
                        <IoCallOutline tabIndex="0" className='font-bold text-xl text-gray-600 hover:text-white' />
                        <ul className="menu border bg-base-100 rounded-md text-black p-2 shadow top-14  dropdown-content w-56">
                            <li className="menu-title text-black">
                                <span className='text-black'>Help Line</span>
                            </li>
                            <li>
                                <a href='/' className='flex gap-x-2'>
                                    <BiRadioCircle />
                                    +880 1677-515579

                                </a>
                            </li>

                            <li>
                                <a href='/' className='flex gap-x-2'>
                                    <BiRadioCircle />
                                    +880 1677-515579

                                </a>
                            </li>

                        </ul>
                    </button>

                    {/* Notification Under Header */}

                    <button className="btn btn-ghost btn-circle bg-white outline-none border-none  dropdown dropdown-end flex justify-center hover:text-white">
                        <AiOutlineBell tabIndex="0" className='font-bold text-xl text-gray-600 hover:text-white' />
                        <ul className="menu border bg-base-100 rounded-md text-black  p-2 shadow top-14  dropdown-content w-64">
                            <div className="">
                                <p className='text-sm text-gray-500 text-left capitalize mt-2 mb-3'>Recent Notifications</p>

                                <div className="flex justify-between">
                                    <div className="">
                                        <p className='text- text-base text-gray-600 text-left capitalize'>Recent Notifications </p>
                                        <p className='text-blue-400 text-left capitalize' style={{ fontSize: "10px" }}>You don't have any notification</p>
                                    </div>
                                    <div className="">
                                        <p className='text-gray-400 text-xs font-extralight'> 02.34pm</p>
                                    </div>
                                </div>

                            </div>


                        </ul>
                    </button>

                    {/* User Under Header */}
                    <button className="btn btn-circle outline-none border-none bg-gradient-to-t hover:from-red-800 hover:to-red-400 from-red-600 to-red-300 dropdown dropdown-end flex justify-center">
                        <AiOutlineUser tabIndex="0" className=' font-bold text-xl text-white ' />
                        <ul className="menu border bg-base-100 rounded-md text-black p-2 shadow top-14  dropdown-content w-56">
                            <li className="menu-title">
                                <span className='text-black'>Hello! Guest</span>
                            </li>
                            <li>
                                <a href='/' className='flex gap-x-2'>
                                    <FaRegCopy />
                                    Purchase History

                                </a>
                            </li>

                            <li>
                                <a href='/' className='flex gap-x-2'>
                                    <AiOutlineLogin />
                                    Log in !

                                </a>
                            </li>

                        </ul>
                    </button>
                </div>
            </div>





        </>

    );
};

export default Header;